import classNames from 'classnames';
import React from 'react';
import Card from 'src/components/Cards/Card';
import {ChecklistGroupShape} from '../../services/ChecklistService';
import Stamp from '../Stamp/Stamp';
import CollapsibleSection from '../collapsible-section';
import ChecklistGroup from './checklist-group';
import styles from './styles.module.scss';

export interface Reward {
  type: string;
  text?: number;
}

export interface ChecklistItem {
  id: string;
  name: string;
  new: boolean;
  completed: boolean;
  reward: Reward;
}

export interface ChecklistYear {
  year: string;
  id: number;
  checklistStatus: 'Incomplete' | 'Complete';
  checklistItems: ChecklistItem[];
}

interface Props {
  groups: ChecklistGroupShape[];
}

const Checklist = ({groups}: Props) => {
  let disabledGroups = 0;
  return groups?.map((item) => {
    if (item.active === false) {
      disabledGroups = disabledGroups + 1;
    }

    let checklistStatus = 'Incomplete';
    if (item.items.every((checklistItem) => checklistItem.completed)) {
      checklistStatus = 'Complete';
    }

    if (disabledGroups <= 1) {
      return (
        <Card key={item._id} className={classNames({[styles.inactiveYear]: !item.active})}>
          <CollapsibleSection
            title={
              <div className={styles.yearContainer} data-testid="checklist-collapsible-section">
                {item.name}
              </div>
            }
            collapseLabel={
              item.active ? (
                <Stamp
                  color={checklistStatus === 'Complete' ? 'green' : 'blue'}
                  className={styles.stamp}
                  data-testid="checklist-status-stamp"
                >
                  {checklistStatus}
                </Stamp>
              ) : (
                <div className={styles.inactiveText}>
                  This checklist will become available to complete in July.
                </div>
              )
            }
            isOpen={item.current}
            disableOpen={!item.active}
            trackIdentifier="checklist-collapsible-section"
          >
            <ChecklistGroup list={item.items} />
          </CollapsibleSection>
        </Card>
      );
    }
  });
};

export default Checklist;
